import type { ExportJobDetail } from "@/types/api";
import { formatDateShort } from "@/utils/format/date";

export function formatExportTitle(job: ExportJobDetail): string {
  if (job.display_title?.trim()) {
    return job.display_title.trim();
  }
  const date = formatDateShort(job.created_at);
  const n = job.invoice_count;
  const suffix = n === 1 ? "invoice" : "invoices";
  return [date, `${n} ${suffix}`].filter(Boolean).join(" · ");
}

export function formatExportSubtitle(job: ExportJobDetail): string {
  return job.job_id;
}

export function formatCreateSource(source?: string | null): string {
  switch (source?.toLowerCase()) {
    case "from_filters":
      return "Search filters";
    case "selection":
      return "Selected rows";
    default:
      return "—";
  }
}
